import React from 'react';
import { useCommunityLang } from '../../context/CommunityLangContext';

/**
 * Floating EN ⇄ HI pill — used on pre-auth onboarding screens so users can
 * switch language before they're inside the main app shell (where
 * `CommunityTopHeader` already provides a toggle).
 *
 * Place it in the top-right of any screen with one line:
 *   <CommunityLangToggle />
 */
const CommunityLangToggle = ({ style }) => {
  const { lang, toggleLang, t } = useCommunityLang();
  const label = lang === 'en' ? t('lang.toggle_to_hi') : t('lang.toggle_to_en');
  return (
    <button
      type="button"
      data-testid="community-lang-toggle"
      aria-label={t('lang.switch_aria')}
      onClick={toggleLang}
      style={{
        position: 'fixed',
        top: 14,
        right: 14,
        zIndex: 50,
        padding: '6px 14px',
        borderRadius: 999,
        background: 'rgba(255,255,255,0.92)',
        border: '1px solid rgba(77,182,172,0.4)',
        color: '#0f766e',
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 0.3,
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(15,118,110,0.12)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        ...(style || {}),
      }}
    >
      {label}
    </button>
  );
};

export default CommunityLangToggle;
